import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { Dispatch } from '../../../../../store';
import { guids, paths } from '../../../../Root/paths';

import DrawerAction from '../../../../../components/Drawer/DrawerAction';
import DrawerContent from '../../../../../components/Drawer/DrawerContent';

import Form from './Form';
import Show from './Show';
import PrivateRoute from '../../../../Root/PrivateRoute';

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    resetArea: d.infrastructureAreas.resetArea,
    resetFocus: d.infrastructureMap.resetFocus
  };
};

type connectedProps = ReturnType<typeof mapDispatch>;

type IProps = connectedProps;

const Area: FC<IProps> = ({ resetArea, resetFocus }) => {
  useEffect(() => {
    return () => {
      resetArea();
    };
  }, []);

  return (
    <>
      <DrawerAction toUrl={paths.map.office.areas.root} onClose={resetFocus} />
      <DrawerContent>
        <Switch>
          {/*<Route path={paths.map.office.areas.create} component={Form} />*/}
          <PrivateRoute
            requirement={{
              uid: guids.map.office.areas.create
            }}
            path={paths.map.office.areas.create}
            component={Form}
          />
          {/*<Route path={paths.map.office.areas.edit()} component={Form} />*/}
          <PrivateRoute
            requirement={{
              uid: guids.map.office.areas.edit()
            }}
            path={paths.map.office.areas.edit()}
            component={Form}
          />
          {/*<Route path={paths.map.office.areas.show()} component={Show} />*/}
          <PrivateRoute
            requirement={{
              uid: guids.map.office.areas.show()
            }}
            path={paths.map.office.areas.show()}
            component={Show}
          />
        </Switch>
      </DrawerContent>
    </>
  );
};

const withConnect = connect(null, mapDispatch);

export default withConnect(Area);
